<div class="split-layout">

  <div class="top-scroll p-3 d-flex justify-content-center">
    <!-- <div class=" w-100 center-card"> -->
    
       
         <div class="w-100 center-card login-card d-flex mx-auto shadow bg-white">
      
          <!-- Panel izquierdo (oculto en móviles) -->
          <div class="left-panel d-none d-lg-flex flex-column justify-content-center align-items-center p-4">
            <h2>{{ 'LOGIN.POWERED_BY' | translate }}</h2>
            <!-- <p>platinium insurance</p>-->
            <div class="brand-logo mt-4" aria-label="Logo de la empresa"></div>

          </div> 
          
          <!-- Formulario login -->
          <div class="right-panel p-4 flex-grow-1">
            <div class="text-center mb-4">
              <div class="brand-logo-small mx-auto" aria-label="Logo"></div>
              <!--   <h5 class="mt-2">Sign in</h5>-->
            </div>
            <title>{{ 'LOGIN.SIGN_IN' | translate }}</title>

            <form (ngSubmit)="startLoginDelay(loginForm)" #loginForm="ngForm">

              <div class="mb-3">
                <label for="username" class="form-label tilte-uf">
                  {{ 'LOGIN.USERNAME' | translate }}
                </label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="username" 
                  name="username" 
                  [(ngModel)]="username" 
                  required     
                  maxlength="70">
              </div>

              <div class="mb-3">
                <label for="password" class="form-label tilte-uf d-flex justify-content-between">
                  <span>{{ 'LOGIN.PASSWORD' | translate }}</span>
                </label>

                <div class="position-relative">
                  <input [type]="showPassword ? 'text' : 'password'"
                        class="form-control pe-5"
                        id="password"
                        name="password"
                        [(ngModel)]="password"
                        required />

                  <i class="bi"
                    [ngClass]="showPassword ? 'bi-eye' : 'bi-eye-slash'"
                  (click)="togglePasswordVisibility()"
                    class="password-toggle-icon"></i>
                </div>
              </div>

              <!-- NUEVO: campo para código de verificación -->
              @if (requires2fa) {
                <div class="mb-3">
                  <div class="mb-3">{{ message2fa() }}</div>
                  <label for="verification_code" class="form-label tilte-uf d-flex justify-content-between">
                    <span>{{ 'LOGIN.VERIFICATION_CODE' | translate }}</span>
                    <small class="text-muted">
                      {{ 'LOGIN.CHECK_EMAIL' | translate }}
                    </small>
                  </label>

                  <input
                    type="text"
                    class="form-control verification-code-input"
                    id="verification_code"
                    name="verification_code"
                    [(ngModel)]="verificationCode"
                    required
                    appOnlyNumbers
                    placeholder="_ _ _ _ _ _"
                    maxlength="6"
                    inputmode="numeric"
                    autocomplete="one-time-code">

                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <small class="text-muted">
                      {{ 'LOGIN.DIDNT_RECEIVE_CODE' | translate }}
                    </small>
                    <!-- <button 
                      type="button" 
                      class="tilte-uf btn btn-link p-0 small"
                      (click)="resendCode(loginForm)"
                      [disabled]="preloading || loading">
                      {{ 'LOGIN.RESEND_CODE' | translate }}
                    </button> -->

                    <button
                      type="button"
                      class="tilte-uf btn btn-link p-0 small resend-button"
                      (click)="resendCode()"
                      [disabled]="
                        preloading ||
                        loading ||
                        resendSeconds > 0
                      ">

                      @if (resendSeconds > 0) {
                        Resend in {{ resendCountdownLabel }}
                      } @else {
                        {{ 'LOGIN.RESEND_CODE' | translate }}
                      }
                    </button>
                  </div>

                  @if (remainingAttempts !== null) {
                    <div class="attempts-divider mt-3 mb-3">
                      <span class="attempts-divider-line"></span>

                      <div class="attempts-divider-content">
                        <i class="bi bi-info-circle me-2"></i>

                        {{ remainingAttempts }}
                        verification
                        {{ remainingAttempts === 1 ? 'attempt' : 'attempts' }}
                        remaining.
                      </div>

                      <span class="attempts-divider-line"></span>
                    </div>
                  }
                </div>
              }


              <div class="check-layout mb-3 ">
                <input 
                  type="checkbox" 
                  class="form-check-input " 
                  id="remember" 
                  [(ngModel)]="rememberMe"
                  name="remember">
                <label 
                  class="form-check-label tilte-uf" 
                  for="remember">
                  {{ 'LOGIN.REMEMBER_ME' | translate }}
                </label>
              </div>

              <div class="d-grid mb-3">
                <button 
                  type="submit" 
                  class="btn btn-gradient p-3"
                  [disabled]="
                    preloading || loading ||
                    (!requires2fa && loginForm.invalid) || 
                    (requires2fa && !verificationCode)">
                  {{
                    requires2fa
                      ? ((preloading || loading)
                          ? ('LOGIN.VERIFYING' | translate)
                          : ('LOGIN.VERIFY_CODE' | translate))
                      : ((preloading || loading)
                          ? ('LOGIN.SIGNING_IN' | translate)
                          : ('LOGIN.SIGN_IN' | translate))
                  }}
                </button>

                @if (showBar) {
                  <div class="progress mt-2" style="height:4px;">
                    <div class="progress-bar progress-bar-striped progress-bar-animated"
                        [style.width.%]="progress"></div>
                  </div>
                }
              </div>

              <!-- Mensaje de error (solo se muestra si errorMessage no es null) -->
              <!-- @if (errorMessage) {
                <div class="alert d-flex align-items-center p-1 fade show custom-error-alert mt-1 mb-2" role="alert">
                  <i class="bi bi-exclamation-circle-fill fs-6 ms-2"></i>
                  <div class="flex-grow-1">
                    {{ errorMessage }} 
                  </div>
                </div>
              } -->
                @if (errorMessage) {
                  <div
                    class="login-feedback d-flex align-items-center fade show mt-0 mb-2"
                    [ngClass]="{
                      'login-feedback-error': messageType === 'error',
                      'login-feedback-success': messageType === 'success',
                      'login-feedback-info': messageType === 'info'
                    }"
                    role="alert">

                    <i
                      class="bi me-2"
                      [ngClass]="{
                        'bi-exclamation-circle-fill': messageType === 'error',
                        'bi-check-circle-fill': messageType === 'success',
                        'bi-info-circle-fill': messageType === 'info'
                      }">
                    </i>

                    <div class="flex-grow-1">
                      {{ errorMessage }}
                    </div>
                  </div>
                }

              <div class="text-center mb-3">
                <a href="#" class="small">
                  {{ 'LOGIN.FORGOT_PASSWORD' | translate }}
                </a>
              </div>

              <div class="d-flex align-items-center mb-3">
                <hr class="flex-grow-1 text-muted m-1">
                <!--  <span class="px-2 text-muted small">or</span>
                <hr class="flex-grow-1 text-muted m-0"> -->
              </div>

              <div class="text-center mt-4">
                <div class="text-center text-muted small mt-3">
                  {{ 'LOGIN.FOOTER_LINE1_PART1' | translate }}
                  <strong>Nexus Internal</strong>
                  {{ 'LOGIN.FOOTER_LINE1_PART2' | translate }}
                </div>
                <div class="text-center text-muted small mt-1">
                  {{ 'LOGIN.FOOTER_LINE2' | translate }}
                  <a href="mailto:soporte&#64;nexus.com">soporte&#64;nexus.com</a>
                    <div class="text-center text-muted small mt-2 opacity-75">
                      v {{ frontVersion }}  • API v {{ apiVersion()?.version}} 
                    </div>
                </div>
              </div>
            </form>
          </div>
      
        </div>
    
    <!-- </div> -->
  </div>

  <div class="bottom-fixed bg-light border-top justify-content-center d-flex align-items-center p-2">
   <footer class="footer ">
    
      <nav class="nav justify-content-center">
        <a class="nav-link text-muted px-3" [routerLink]="['/legal/terms']">
          {{ 'LOGIN.TERMS' | translate }}
        </a>
        <a class="nav-link text-muted px-3" [routerLink]="['/legal/privacy']">
          {{ 'LOGIN.PRIVACY' | translate }}
        </a>
        <a class="nav-link text-muted px-3" [routerLink]="['/legal/cookies']">
          {{ 'LOGIN.COOKIES' | translate }}
        </a>
        <a class="nav-link text-muted px-3" [routerLink]="['/legal/accessibility']">
          {{ 'LOGIN.ACCESSIBILITY' | translate }}
        </a>
        <div class="nav-link px-3" [ngClass]="environmentClass">
          {{ frontEnvLabel }}
        </div>
      </nav>

      

    </footer>
  </div>

</div>